var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftNavMain"}},[_c('start-nav'),_c('first-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }